<h1 matDialogTitle>{{ 'CAMPAIGN_RESULT.SORT_RESULT_TITLE' | translate }}</h1>
<div mat-dialog-content>
    <p>{{ 'CAMPAIGN_RESULT.SORT_CRITERIA' | translate }}</p>
    <table class="sort-condition-table">
        <tr>
            <td>{{ 'CAMPAIGN_RESULT.SORT_CRITERIA_LABEL' | translate }} 1:</td>
            <td>
                <mat-form-field appearance="outline" fxFlex="200px">
                    <mat-select [(ngModel)]="condition1">
                        <mat-option
                            *ngFor="let condition of conditionList"
                            [value]="condition"
                        >
                            {{ condition.name }}
                        </mat-option>
                    </mat-select>
                </mat-form-field>
            </td>
            <td>
                <div class="icon-wrapper">
                    <mat-icon
                        class="icon-sort-by"
                        [ngStyle]="getColor(condition1.isAsc)"
                        (click)="condition1.isAsc = !condition1.isAsc"
                    >
                        {{
                            condition1.isAsc ? 'arrow_upward' : 'arrow_downward'
                        }}
                    </mat-icon>
                </div>
            </td>
        </tr>

        <tr>
            <td>{{ 'CAMPAIGN_RESULT.SORT_CRITERIA_LABEL' | translate }} 2:</td>
            <td>
                <mat-form-field appearance="outline" fxFlex="100">
                    <mat-select [(ngModel)]="condition2">
                        <mat-option
                            *ngFor="let condition of conditionList"
                            [value]="condition"
                        >
                            {{ condition.name }}
                        </mat-option>
                    </mat-select>
                </mat-form-field>
            </td>
            <td>
                <div class="icon-wrapper">
                    <mat-icon
                        class="icon-sort-by"
                        [ngStyle]="getColor(condition2.isAsc)"
                        (click)="condition2.isAsc = !condition2.isAsc"
                    >
                        {{
                            condition2.isAsc ? 'arrow_upward' : 'arrow_downward'
                        }}
                    </mat-icon>
                </div>
            </td>
        </tr>

        <tr>
            <td>{{ 'CAMPAIGN_RESULT.SORT_CRITERIA_LABEL' | translate }} 3:</td>
            <td>
                <mat-form-field appearance="outline" fxFlex="100">
                    <mat-select [(ngModel)]="condition3">
                        <mat-option
                            *ngFor="let condition of conditionList"
                            [value]="condition"
                        >
                            {{ condition.name }}
                        </mat-option>
                    </mat-select>
                </mat-form-field>
            </td>
            <td>
                <div class="icon-wrapper">
                    <mat-icon
                        class="icon-sort-by"
                        [ngStyle]="getColor(condition3.isAsc)"
                        (click)="condition3.isAsc = !condition3.isAsc"
                    >
                        {{
                            condition3.isAsc ? 'arrow_upward' : 'arrow_downward'
                        }}
                    </mat-icon>
                </div>
            </td>
        </tr>

        <tr>
            <td>{{ 'CAMPAIGN_RESULT.SORT_CRITERIA_LABEL' | translate }} 4:</td>
            <td>
                <mat-form-field appearance="outline" fxFlex="100">
                    <mat-select [(ngModel)]="condition4">
                        <mat-option
                            *ngFor="let condition of conditionList"
                            [value]="condition"
                        >
                            {{ condition.name }}
                        </mat-option>
                    </mat-select>
                </mat-form-field>
            </td>
            <td>
                <div class="icon-wrapper">
                    <mat-icon
                        class="icon-sort-by"
                        [ngStyle]="getColor(condition4.isAsc)"
                        (click)="condition4.isAsc = !condition4.isAsc"
                    >
                        {{
                            condition4.isAsc ? 'arrow_upward' : 'arrow_downward'
                        }}
                    </mat-icon>
                </div>
            </td>
        </tr>

        <tr>
            <td>{{ 'CAMPAIGN_RESULT.SORT_CRITERIA_LABEL' | translate }} 5:</td>
            <td>
                <mat-form-field appearance="outline" fxFlex="100">
                    <mat-select [(ngModel)]="condition5">
                        <mat-option
                            *ngFor="let condition of conditionList"
                            [value]="condition"
                        >
                            {{ condition.name }}
                        </mat-option>
                    </mat-select>
                </mat-form-field>
            </td>
            <td>
                <div class="icon-wrapper">
                    <mat-icon
                        class="icon-sort-by"
                        [ngStyle]="getColor(condition5.isAsc)"
                        (click)="condition5.isAsc = !condition5.isAsc"
                    >
                        {{
                            condition5.isAsc ? 'arrow_upward' : 'arrow_downward'
                        }}
                    </mat-icon>
                </div>
            </td>
        </tr>
    </table>
</div>
<div mat-dialog-actions class="pt-24 pb-24 center">
    <div class="button-wrapper">
        <button
            mat-raised-button
            color="accent"
            (click)="dialogRef.close(getReturnValue())"
        >
            {{ 'CAMPAIGN_RESULT.SORT_BTN' | translate }}
        </button>
        <button
            mat-raised-button
            color="primary"
            class="ml-16"
            (click)="dialogRef.close(false)"
        >
            {{ 'CAMPAIGN_RESULT.SORT_BACK_BTN' | translate }}
        </button>
    </div>
</div>
